import { useStore } from '@src/stores-v2/StoreContext';
import { LogManager } from '@src/utility/Logger';
import { useEffect, useRef } from 'react';

import { useVideoEditorLogging } from './useVideoEditorLogging';

export const logger = LogManager.getLogger('hook:useHeadlessEditorIntegration');

export function useHeadlessEditorLogging(
  enableDebugTools: boolean = true,
  enableLogging: boolean = typeof process !== 'undefined' &&
    process.env.NODE_ENV === 'development',
) {
  const { editorStore, videoSourceStore } = useStore();

  // Set up VideoEditor logging if enabled
  useVideoEditorLogging(
    editorStore?.editor,
    {
      enableCommandLogging: enableLogging,
      enableBatchLogging: enableLogging,
      enablePerformanceLogging: enableLogging && enableDebugTools,
      detailedCommandPerformance: enableDebugTools,
    },
    enableLogging,
  );

  const editorRef = useRef<typeof editorStore | null>(editorStore);

  // Creatomate <-> Stores (MobX - VideoSourceStore, TranscriptStore) <-> VideoEditor
  useEffect(() => {
    // Debug helpers (window globals)
    if (enableDebugTools && typeof window !== 'undefined') {
      (window as any).__headlessEditor = editorStore;
      (window as any).__videoSourceStore = videoSourceStore;
    }

    // 🧹  Cleanup
    return () => {
      if (enableDebugTools && typeof window !== 'undefined') {
        delete (window as any).__headlessEditor;
        delete (window as any).__videoSourceStore;
      }
    };
  }, []);

  return editorRef;
}
